<template>
  <div class="skeleton" :style="{ width: !fullWidth ? `${width}px` : '100%', height:`${height}px`}">{{ label }}</div>
</template>

<script>
export default {
  name: "SkeletonLoading",
  props: {
    width: {
      type: Number,
      default: 75
    },
    height: {
      type: Number,
      default: 15
    },
    label: String,
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.skeleton {
  display: block;
  background-color: rgb(142 142 149 / 20%);
  height: auto;
  border-radius: 0.2rem;
  animation: 2s ease-in-out 0.5s infinite normal none running skeletonLoading;
  font-size: 1rem;
  margin: 5px;
  text-align: center
}

.dark-layout {
  .skeleton {
    border: solid 1px #433f3f;
  }
}

@keyframes skeletonLoading {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
</style>
